import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './language/LanguageContext';
import Landingpage from './Landingpage';
import Login from './Login';
import Register from './Register';
import Home from './Home';
import MyCategories from './MyCategories';
import ItemList from './ItemList';
import UpdatePrice from './UpdatePrice';
import RFQs from './RFQs';
import Orders from './Orders'
import RFQDetails from './RFQDetails';
import OrderDetails from './OrderDetails';
import ViewItems from './ViewItems';
import ProtectedRoute from './components/ProtectedRoute';
import Notifications from './Notifications';
import ProfileAccount from './ProfileAccount';
import { BrowserRouter } from "react-router-dom";/* 
import DeliveryPartnerPage from './deliveryPartnerPage';
 */
import DPLogin from '../DeliveryPartner/Login';
import Rides from '../DeliveryPartner/Rides';
import DeliveryPartnerPage from '../DeliveryPartner/DeliveryPartnerPage';

function App() {
  return (

    <LanguageProvider>
      <Routes>
        <Route path='/supplier/deliveryPartner/login' element={<DPLogin/>} />
        <Route path='/supplier/deliveryPartner/rides' element={<Rides/>} />
        <Route path='/supplier/items/delivery' element={<DeliveryPartnerPage />} />
        <Route path='/supplier' element={<Landingpage />} />
        <Route path='/supplier/login' element={<Login />} />
        <Route path='/supplier/register' element={<Register />} />
        
        {/* Protected routes */}
        <Route path='/supplier/home' element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />
        <Route path='/supplier/mycategories' element={
          <ProtectedRoute>
            <MyCategories />
          </ProtectedRoute>
        } />
        <Route path='/supplier/itemlist' element={
   
            <ItemList />
      
        } />
         <Route path='/supplier/priceupdate' element={
          <ProtectedRoute>
            <UpdatePrice />
          </ProtectedRoute>
        } />
         <Route path='/supplier/rfqs' element={
          <ProtectedRoute>
            <RFQs />
          </ProtectedRoute>
        } />
        <Route path='/supplier/rfqdetails' element={
          <ProtectedRoute>
            <RFQDetails />
          </ProtectedRoute>
        } />
        <Route path='/supplier/orders' element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        } />
        <Route path='/supplier/orderdetails' element={
          <ProtectedRoute>
            <OrderDetails />
          </ProtectedRoute>
        } />
        <Route path='/supplier/viewitems' element={
          <ProtectedRoute>
            <ViewItems />
          </ProtectedRoute>
        } />
         <Route path='/supplier/notifications' element={
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        } />
        <Route path='/supplier/profile' element={
          <ProtectedRoute>
            <ProfileAccount />
          </ProtectedRoute>
        } />
      </Routes>
    </LanguageProvider>
  );
}

export default App;
